"use strict";
/**
 * Generates null value.
 *
 * @returns {null}
 */
function nullGenerator() {
    return null;
}
module.exports = nullGenerator;



//////////////////
// WEBPACK FOOTER
// ./~/json-schema-faker/lib/generators/null.js
// module id = 1328
// module chunks = 1